<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退货单号</label>
            <span class="weui-form-preview__value">{{initData.pi_inoutno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据类型</label>
            <span class="weui-form-preview__value">{{initData.pi_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">退货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.pi_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.cu_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.pi_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value">{{initData.pi_contact}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物流单号</label>
            <span class="weui-form-preview__value">{{initData.expressInfo}}</span>
          </div> -->
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in initData.listDetail" :key="index">
          <div class="form-detail-preview_num">{{ index + 1 }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户料号</label>
            <span class="weui-form-preview__value">{{item.pupdprcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">待退货数量</label>
            <span class="weui-form-preview__value">{{item.qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO号</label>
            <span class="weui-form-preview__value">{{item.pucode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出货单号</label>
            <span class="weui-form-preview__value">{{item.sapdcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出货行号</label>
            <span class="weui-form-preview__value">{{item.sapddetno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">销售单号</label>
            <span class="weui-form-preview__value">{{item.sdcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">销售行号</label>
            <span class="weui-form-preview__value">{{item.sddetno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{item.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.pupdnetprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.pupdprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.pupdtotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">批次号</label>
            <span class="weui-form-preview__value">{{item.pupdbatchcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">生产日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.pupdmadetime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">保质期(天)</label>
            <span class="weui-form-preview__value">{{item.pupdshelflife}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">保质期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.pupdlifedate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  },
  data() {
    return {

    }
  },
  methods: {

  },
};
</script>